import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonConstant } from '../enums/common-constant';
import { isPlatformBrowser } from '@angular/common';
import {
  UserLoginResponseModel,
  UserLoggedInModel,
} from '../models/authen.model';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  isAuthentication = new BehaviorSubject<boolean | null>(null);
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      const token = this.getToken();
      if (token) {
        this.updateToken(true);
      } else {
        this.updateToken(false);
      }
    }
  }

  updateToken(status: boolean) {
    this.isAuthentication.next(status);
  }
  setToken(token: string) {
    this.updateToken(true);
    if (this.isBrowser) {
      localStorage.setItem(CommonConstant.CURRENT_TOKEN, token);
    }
  }

  getToken(): string | null {
    return localStorage
      ? localStorage.getItem(CommonConstant.CURRENT_TOKEN)
      : '';
  }

  removeToken() {
    this.updateToken(false);
    if (window?.localStorage) {
      localStorage.removeItem(CommonConstant.CURRENT_TOKEN);
    }
  }

  setUserData(user: UserLoggedInModel) {
    if (this.isBrowser) {
      localStorage.setItem(CommonConstant.CURRENT_USER, JSON.stringify(user));
    }
  }

  getUserData(): any | null {
    return localStorage
      ? localStorage.getItem(CommonConstant.CURRENT_USER)
      : '';
  }

  removeUserData() {
    if (window?.localStorage) {
      localStorage.removeItem(CommonConstant.CURRENT_USER);
    }
  }

  setUserPermissions(user: UserLoginResponseModel) {
    if (this.isBrowser) {
      localStorage.setItem(
        CommonConstant.CURRENT_USER_PERMISSIONS,
        JSON.stringify(user),
      );
    }
  }

  getUserPermissions(): any | null {
    return localStorage
      ? localStorage.getItem(CommonConstant.CURRENT_USER_PERMISSIONS)
      : '';
  }

  removeUserPermissions() {
    if (window?.localStorage) {
      localStorage.removeItem(CommonConstant.CURRENT_USER_PERMISSIONS);
    }
  }
}
